import { withErrorBoundary } from "@sentry/nextjs";
import { gql } from "graphql-request";
import { FC, HTMLAttributes } from "react";
import { IntroductionIndividualSectionContent } from "types/graphql/generated";
import { Item } from ".";

interface Props {
  className?: HTMLAttributes<HTMLDivElement>["className"];
  content: IntroductionIndividualSectionContent;
}

const IndividualSection: FC<Props> = withErrorBoundary(
  ({ className = "", content: { title, link, linkLabel, description } }) => {
    return (
      <div className={className}>
        <h2 className="mb-6 w-max max-w-full text-wrap rounded-[32px] bg-eucalyptus-30 px-8 py-3 text-xl font-semibold text-eucalyptus-80 xs:text-2xl sm:text-nowrap md:mb-8 lg:mb-10">
          {title}
        </h2>
        <div className="w-full">
          <Item link={link} label={linkLabel} description={description} />
        </div>
      </div>
    );
  },
  {}
);

gql`
  fragment IntroductionIndividualSectionContent on ComponentNestedIntroductionIndividualSection {
    title
    link
    linkLabel
    description
  }
`;

export { IndividualSection };
